const THREE = require('three')
import {loadingManager, load, registerSize} from '../loader'
import {TimelineMax, Cubic} from 'gsap'
import sounds from '../sounds'
import {perfectZ} from '../camera-ui'

export let mesh = new THREE.Object3D()
export default mesh
mesh.visible = false

let spriteUrls = [
  {
    url: require('assets/countdown/3.png'),
    size: 520
  },
  {
    url: require('assets/countdown/2.png'),
    size: 1332
  },
  {
    url: require('assets/countdown/1.png'),
    size: 1318
  }
]

export let sprites = []

const initSprite = function (data, index) {

  registerSize(data.url, data.size)

  load(data.url, new THREE.TextureLoader(loadingManager), (results)=> {

    let spriteMaterial = new THREE.SpriteMaterial({
      map: results[0],
      // useScreenCoordinates: false,
      color: 0xff0000,
      alphaMap: null,
      transparent: true,
      alphaTest: 0.01
    })
    let sprite = new THREE.Sprite( spriteMaterial )
    sprite.scale.setScalar(150)
    // sprite.depthTest = false
    // sprite.depthWrite = false

    sprite.position.y = 0
    sprite.position.z = perfectZ
    sprites[index] = sprite

    mesh.add(sprite)


  })
}

for (var i = 0; i < spriteUrls.length; i++) {
  initSprite(spriteUrls[i], i)
}


export const play = function () {
  return new Promise((resolve)=> {
    mesh.visible = true
    // let sound = sounds.getAudio('countdown')
    // console.log(1111, sound)
    setTimeout(()=> {
      sounds.countdown.audio.play()
    }, 300)

    let tl = new TimelineMax({onComplete: ()=> {
      // sounds.countdown.audio.stop()
      resolve()
      mesh.visible = false
    }})
    for (let sprite of sprites) {

      // reset
      sprite.material.opacity = 1
      sprite.material.needsUpdate = true
      sprite.position.z = perfectZ

      // play
      tl.to(sprite.position, 0.3, {z: 0, ease: Cubic.easeInOut})
      tl.to(sprite.position, 0.3, {z: -perfectZ * 100, ease: Cubic.easeInOut, delay: 0.4})
      tl.to(sprite.material, 0.3, {opacity: 0, ease: Cubic.easeInOut, delay: 0, onUpdate: ()=> { sprite.material.needsUpdate = true }}, '-=0.3')
    }
    tl.to({}, 1.0, {})
    tl.play()
  })
}




// WEBPACK FOOTER //
// ./src/components/game/ui/countdown.js